export default ({ extraText, clock }) => [
  {
    title: 'Дополнительный </br>текст, телефон', value: extraText.position, parentName: 'extraText',
  },
  {
    title: 'Дата, время', value: clock.position, parentName: 'clock',
  },
];
